import { Typography } from "@mui/material";

export default function EndOfInfiniteListMessage() {
    return (
        <Typography
            color="text.secondary"
            sx={{ textAlign: "center", mt: 4, mb: 2 }}
        >
            شما به انتهای لیست رسیده اید
        </Typography>
    );
}
